import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView } from '@/components/base'
import { RowItem } from '@/components/composites'
import { AlertDescription } from '@/components/AlertDescription'
import { AdaptedGoalTransferDTO } from '@/domain/transfer/transferTypes'
import { useFormatSavingTransfer } from '@/hooks/useFormatSavingTransfer'
import { links } from '@/constants/links'
import { openLink } from '@/utils'

interface TransferDetailsInfosProps extends Partial<AdaptedGoalTransferDTO> {
  isLoading?: boolean
}

export const TransferDetailsInfos: React.FC<TransferDetailsInfosProps> = (
  goalTransfer,
) => {
  const { t } = useTranslation()

  const formattedSavingTransfer = useFormatSavingTransfer({ goalTransfer })

  return (
    <BaseView style={{ width: '100%' }} gap={20}>
      {formattedSavingTransfer?.map((item) => {
        if (!item.isVisible) return null

        return (
          <RowItem
            key={item.id}
            skeletonActive={!!goalTransfer?.isLoading}
            {...item}
          />
        )
      })}

      {!goalTransfer?.isLoading && (
        <AlertDescription
          description={t('translation:contactUsDescription')}
          linkText={`${t('translation:contactSupport')}.`}
          onPressLink={() => openLink(links?.support)}
        />
      )}
    </BaseView>
  )
}
